// extracted by mini-css-extract-plugin
export default {"typePart":"ingredients-type-list_typePart__8sCLc","listCards":"ingredients-type-list_listCards__ZdbI1"};